var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "whatsapp-wrapper" }, [
    _c("iframe", {
      staticStyle: { border: "0" },
      attrs: { width: "100", height: "50", src: _vm.whatsAppLink },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }